// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner[data-v-6d905326]{padding:19px;background-color:#ffe9a4;text-align:center}", ""]);
// Exports
module.exports = exports;
